export default {
	title: "Szerencsekerekek",
	Lucky: "Szerencsés",
	wheels: "Kerekek",
	winningrecord: "Nyereményrekord",
	ActivityRules: "Tevékenységi Szabályok",
	ActivityRulesContent: "További információkért a sorsolásról kérjük, vegye fel a kapcsolatot ügyfélszolgálatunkkal.",
	award: {
		title: "Gratulálunk a nyereményhez!",
		btn: "Nyeremény átvétele"
	},
	noticeItem: "{0} megszerezte {1}",
	lotteryDraws: "{0} lottósorsolás",
	noAvailableTimes: "Nincs elegendő próbálkozás. Kérjük, lépjen kapcsolatba az ügyfélszolgálattal.",
	noOpen: "Még nem nyitott",
	noWinning: "Kitartóan próbálkozzon",
	ViewALlPrizes: "Összes nyeremény megtekintése",
	myPrizes: "Saját nyeremények",
	share: "Megosztás egy baráttal"
};
